module.exports = __webpack_public_path__ + "media/brands/volvo-fbc368a7.png";